
import {Component, Prop, Vue} from 'vue-property-decorator';
import RulesUtil from "@/util/rules";
import ClienteService from "@/service/cliente.service";
import Listas from "@/models/lists/listas.model";
import ClienteModel from "@/models/cliente/cliente.model";
import FormatUtil from "@/util/format.util";
import {namespace} from "vuex-class";
import {MapActionsCliente} from "@/store/modules/cliente/map-actions.cliente";

const clienteStore = namespace('cliente');

@Component({
  name: "dados-cliente-component"
})
export default class DadosClienteComponent extends Vue {

  @clienteStore.Action(MapActionsCliente.SALVAR_CLIENTE_ATUAL) salvarClienteAtual;

  @Prop({type: Object, default: new ClienteModel()})
  public cliente!: ClienteModel;

  @Prop({type: Number})
  public step!: number;

  private rules = RulesUtil;
  private listas = new Listas();

  async saveUpdateDados() {
    if ((this.$refs.formDados as HTMLFormElement).validate()) {
      let retorno: ClienteModel;
      if (this.cliente.id) {
        retorno = await ClienteService.atualizar(this.cliente);
      } else {
        retorno = await ClienteService.cadastrar(this.cliente);
      }
      retorno.cpf_cnpj = FormatUtil.cpfCnpj(retorno.cpf_cnpj);
      this.salvarClienteAtual(retorno);
      this.$emit("retornoCliente", retorno);
    }
  }

  formatarCnpjCpf() {
    this.cliente.cpf_cnpj = FormatUtil.cpfCnpj(this.cliente.cpf_cnpj);
  }

  nextStep() {
    this.$emit("nextStep", 2);
  }

}
